import React, {useState} from "react";
import {Button, Modal, Table} from "antd";
import {defaultSorter, IconPopup} from "../utils/antdhelper/AntdHelper";
import {DeleteOutlined, DeleteTwoTone, EditTwoTone} from "@ant-design/icons";
import RoutingForm from "../components/Forms/RoutingForm";
import FlkForm from "../components/Forms/FlkForm";

const columnsFlk = [
    {title: "Условие 1",   dataIndex: "cond1"},
    {title: "Условие 2",   dataIndex: "cond2"},
    {title: "Связь",       dataIndex: "link"},
    {title: "Этап",        dataIndex: "step"},
    {title: "Тип",         dataIndex: "type"},
    {title: "Применимость",         dataIndex: "apply"},
    {title: "Действия",           dataIndex: "idx",
        render: (text, record) => <>
            <IconPopup Icon={EditTwoTone}><RoutingForm/></IconPopup>
            <IconPopup Icon={DeleteTwoTone} twoToneColor="#eb2f96"></IconPopup>
        </>},
].map(column =>
    ({
        ...column,
        sorter: defaultSorter(column),
        key: column.dataIndex
    }))

const defaultRouting = [{
    patients: 'Диагноз:Топография ~ С50',
    step: '[1] Подозрение на ЗНО',
    serv: 'Осмотр онколога',
    area: 'Все',
    type: 'Обязательно',
    time: '3',
    target: 'РКОД: кабинет <1-24>, РКОД: кабинет <2-41>',
    idx: '1'
}]

const FlkPage = () => {
    const [visible, setVisible] = useState(false)
    const doClose = () => setVisible(false)
    return <div>
        <Modal
            visible={visible}
            onOk={doClose}
            onCancel={doClose}
            width={1000}>
            <FlkForm></FlkForm>
        </Modal>
        <Table
            columns={columnsFlk}
            dataSource={[]}
            title={
                () => <>Список дополнительных ФЛК
                    <Button style={{float: 'right'}} type="primary" onClick={() => setVisible(true)}>Добавить</Button>
                    <Button style={{float: 'right'}}>Импорт</Button>
                    <Button style={{float: 'right'}}>Экспорт</Button>
                </>
            }/>
    </div>
}

export default FlkPage